@if (content) {
  <div class="content text-center color-{{ content.color }}">
    <wagtail-page-element-image
      [image]="content.picture_tag_info"
      [width]="1920"
      [height]="600"
      sizes="100vw"
    ></wagtail-page-element-image>
    <div class="position-absolute top-50 start-50 translate-middle">
      @if (content.logo && content.logo.length > 0) {
        <div class="logo" [ngStyle]="getLogo()"></div>
      }
      @if (content.title1 || content.title2) {
        <div class="heading p-3">
          @if (content.title1) {
            <div class="first">{{ content.title1 }}</div>
          }
          @if (content.title2) {
            <div class="second">{{ content.title2 }}</div>
          }
        </div>
      }
    </div>
  </div>
}
